import { Copy, DollarSign, ExternalLink } from "lucide-react";
import { toast } from "sonner";

const QR_URL =
  "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/7hruk184_IMG_2655.jpeg";

export default function PaymentSection({
  cashappHandle = "$biipodmodding",
  price = 120,
  packageName = "",
  confirmed,
}) {
  const copy = () => {
    navigator.clipboard.writeText(cashappHandle);
    toast.success("CashApp handle copied");
  };
  const cashappUrl = `https://cash.app/${cashappHandle.replace("$", "$")}`;

  return (
    <aside className="relative border border-zinc-800 bg-[#0a0a0a] bo2-corners" data-testid="payment-section">
      <header className="flex items-center justify-between border-b border-zinc-800 bg-black px-5 py-3">
        <div className="flex items-center gap-3">
          <DollarSign className="h-4 w-4 text-[#ff6b00]" />
          <span className="font-mono-hud text-xs uppercase tracking-widest text-zinc-400">
            payment_terminal <span className="text-[#ff6b00]">// cashapp</span>
          </span>
        </div>
        <span className="font-mono-hud text-[10px] uppercase tracking-widest text-zinc-500">
          ${price} USD
        </span>
      </header>

      <div className="p-6 sm:p-8">
        <div className="font-mono-hud text-xs uppercase tracking-[0.4em] text-[#ff6b00]">
          // Objective
        </div>
        <h3 className="mt-3 font-display text-3xl uppercase tracking-tight text-zinc-100">
          {confirmed ? "Confirm & Send Payment" : "Payment Instructions"}
        </h3>
        <p className="mt-2 font-hud text-sm text-zinc-400">
          {packageName ? (
            <>
              For <span className="text-[#ff6b00]">{packageName}</span>: scan the CashApp
              QR or pay the handle directly. Then message Biipod on Discord with your
              order ID.
            </>
          ) : (
            <>
              Scan the CashApp QR or pay the handle directly. Then message Biipod on
              Discord with your order ID.
            </>
          )}
        </p>

        <div className="relative mt-6 border border-[#ff6b00]/40 bg-white p-4 bo2-glow-orange">
          <img
            src={QR_URL}
            alt="CashApp QR code for $biipodmodding"
            data-testid="cashapp-qr"
            className="mx-auto block h-auto w-full max-w-[280px]"
          />
        </div>

        <div className="mt-6 grid gap-3">
          <button
            onClick={copy}
            data-testid="copy-cashapp-handle"
            className="group flex items-center justify-between border border-zinc-800 bg-black p-4 transition-colors duration-150 hover:border-[#ff6b00]"
          >
            <div className="text-left">
              <div className="font-mono-hud text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                CashApp Handle
              </div>
              <div className="mt-1 font-display text-2xl tracking-wide text-[#ff6b00]">
                {cashappHandle}
              </div>
            </div>
            <Copy className="h-4 w-4 text-zinc-500 group-hover:text-[#ff6b00]" />
          </button>

          <a
            href={cashappUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="open-cashapp"
            className="inline-flex items-center justify-center gap-2 border-2 border-[#ff6b00] bg-[#ff6b00] px-4 py-3 font-hud text-sm font-semibold uppercase tracking-widest text-black transition-transform duration-150 hover:-translate-y-0.5 hover:bg-[#ff8125]"
          >
            Open CashApp <ExternalLink className="h-4 w-4" />
          </a>
        </div>

        <ol className="mt-8 space-y-4 border-t border-zinc-900 pt-6">
          <Instruction n="01" text={`Send $${price} to ${cashappHandle} via CashApp.`} />
          <Instruction
            n="02"
            text="Screenshot the payment receipt for verification."
          />
          <Instruction
            n="03"
            text="DM Biipod on Discord with your Order ID and receipt."
          />
          <Instruction
            n="04"
            text="Once Biipod picks up your order, unlock is delivered in ~5 minutes (short queue possible during high volume)."
          />
        </ol>
      </div>
    </aside>
  );
}

function Instruction({ n, text }) {
  return (
    <li className="flex items-start gap-4">
      <span className="grid h-8 w-8 flex-none place-items-center border border-[#ff6b00]/50 bg-black font-display text-sm text-[#ff6b00]">
        {n}
      </span>
      <span className="font-hud text-sm text-zinc-300">{text}</span>
    </li>
  );
}
